import { Injectable } from '@angular/core'

import { map, Observable } from 'rxjs';
import {
  BackendService,
  TrackingService,
  ApiService,
  SharedObjectBaseService,
  RequestOptionsArgs,
} from '@hub-components'
import { Dashboard, DashboardJson } from '../models/dashboard.model';
import { DashboardsResponse } from '../models/dashboards-response.model';

@Injectable()
export class SharedDashboardsService extends SharedObjectBaseService {
  constructor(
    private backendService: BackendService,
    private apiService: ApiService
  ) {
    super()
  }

  list(options: RequestOptionsArgs = {}): Observable<DashboardsResponse> {
    return this.backendService.load('/shared_dashboards', options).pipe(
      map((response: { dashboards: DashboardJson[], dashboards_count: number }) => {
        return {
          dashboards: response.dashboards.map(dashboard => new Dashboard(dashboard)),
          dashboardsCount: response.dashboards_count,
        };
      }),
    );
  }

  sharedObject(uuid) {
    return this.apiService
      .load(`/shared_objects/${uuid}`, { skipLoader: true, throwErrors: true })
  }

  create(dashboardId, permissions, invites, note, skip) {
    return this.backendService
      .create(`/shared_dashboards`, { share: { shared_object_id: dashboardId, dashboard_id: dashboardId, app: 'studio', note, skip, invites, dates: permissions.dates, global_filters: permissions.global_filters }})
  }

  update(shareUuid: string, payload: any) {
    return this.apiService
      .update(`/shared_objects/${shareUuid}`, { payload }, { skipLoader: true })
  }

  add(shareUuid, invites: any[], note, skip) {
    return this.backendService
      .create(`/shared_dashboards/${shareUuid}/invites`, { share: { invites, note, skip }})
  }

  remove(shareUuid, invite) {
    return this.backendService.delete(`/shared_dashboards/${shareUuid}/invites/${invite}`)
  }

  exportDashboard(shareUuid, dashboardId, interval: string, format: string) {
    return this.backendService.create(`/shared_dashboards/${shareUuid}/${dashboardId}/export`, { interval: interval, format: format })
  }

  exportWidget(shareUuid: string, dashboardId: number, pageId: number, widgetIndex: number, interval: string) {
    return this.backendService.create(`/shared_dashboards/${shareUuid}/${dashboardId}/export_widget`, { page_id: pageId, widget_index: widgetIndex, interval: interval });
  }
}
